import { render, staticRenderFns } from "./FamilyCounselling.vue?vue&type=template&id=68a10cbc"
import script from "./FamilyCounselling.vue?vue&type=script&lang=js"
export * from "./FamilyCounselling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports